<app-sub-header [title]="'Meus dados'"></app-sub-header>
<div
  class="background"
  style="height: 100%; background: #fffbff; padding-top: 30px"
>
  <div *ngIf="loading" class="spinner">
    <mat-spinner></mat-spinner>
  </div>

  <div
    *ngIf="!loading"
    style="
      background: #fff;
      max-width: 750px;
      min-width: 400px;
      margin: 0 auto;
      padding: 30px;
    "
  >
    <div class="container user-data-content">
      <p class="user-data-header mb-4">Alterar Senha</p>
      <form
        style="margin: 0 auto; align-items: center"
        class="col-sm-8"
        [formGroup]="passwordForm"
      >
        <div class="form-group">
          <label for="currentPassword">Senha atual:</label>
          <input
            type="password"
            class="form-control"
            id="currentPassword"
            formControlName="currentPassword"
            [ngClass]="{ 'light-red-bg': wrongPassword }"
          />
        </div>
        <div class="form-group">
          <label for="newPassword">Nova senha:</label>
          <input
            type="password"
            class="form-control"
            id="newPassword"
            formControlName="newPassword"
            [ngClass]="{ 'light-red-bg': missingRequirements }"
          />
        </div>
        <div class="form-group">
          <label for="newPasswordConfirmation">Confirmar senha:</label>
          <input
            type="password"
            class="form-control"
            id="newPasswordConfirmation"
            aria-describedby="newPasswordHelp"
            formControlName="newPasswordConfirmation"
            [ngClass]="{ 'light-red-bg': wrongConfirmation }"
          />
          <small id="newPasswordHelp" class="form-text text-muted">
            * A senha deve ter no mínimo 6 caracteres. <br />
            * A senha deve ter pelo menos uma letra maiúscula e uma letra
            minúscula. <br />
            * A senha deve ter pelo menos um número. <br />
            * A senha deve ter pelo menos um caractere especial (@ # $ % &
            *).</small
          >
        </div>
        <div class="form-group row mt-4" style="float: right">
          <button class="btn-edit-profile m-1">
            <span>Cancelar</span>
          </button>
          <button (click)="changePassword()" class="btn-primary m-1">
            Alterar Senha
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
